<!--<c-footer>-->
  <div class="ms-auto">
    Powered by
    <a href="https://coreui.io/angular" target="_blank">
      <span> BuildSpace</span>
    </a>
  </div>
<!--</c-footer>-->
